<div class="rights-box" [formGroup]="rightsForm">
    <div formArrayName="rightsGroup">
        <mat-card>
            <mat-card-content>
                <div class="actions">
                    <mat-form-field class="filter-select">
                        <mat-label>{{ 'Right.RightsFilterLabel' | translate }}</mat-label>
                        <input
                            autocomplete="off"
                            class="primary-button"
                            placeholder="{{ 'Right.FilterLabel' | translate }}"
                            class="search-input"
                            #search
                            matInput
                            type="text"
                            [(ngModel)]="searchRight"
                            [ngModelOptions]="{ standalone: true }" />
                        @if (search.value.length > 0) {
                            <button matSuffix mat-icon-button class="primary-button" (click)="resetSearch()">
                                <mat-icon>close</mat-icon>
                            </button>
                        }
                        @if (search.value.length < 1) {
                            <mat-icon class="primary-button" matSuffix>search</mat-icon>
                        }
                    </mat-form-field>

                    @if (!isExternal && !readonly) {
                        <button class="accent-button addButton" mat-icon-button type="button" matTooltip="{{ 'Right.AddRight' | translate }}" (click)="AddItems()">
                            <mat-icon>add_circle</mat-icon>
                        </button>
                    }
                </div>

                @for (right of rightsForm.get('rightsGroup')['controls'] | formArrayFilterPipe: searchRight; track right; let i = $index) {
                    <div class="right">
                        <div class="right-container" [formGroupName]="i">
                            <mat-slide-toggle class="primary-button right-toggle" formControlName="value" (change)="onChanges(right.controls.name.value)">
                                {{ getRightTranslate(right.controls.name.value) }}
                            </mat-slide-toggle>
                            @if (!isExternal) {
                                <mat-checkbox class="primary-button" formControlName="readonly">{{ 'Right.Readonly' | translate }}</mat-checkbox>
                            }
                            @if (affinity !== 'User' || !isExternal) {
                                <mat-checkbox class="primary-button" formControlName="legacyable">{{ 'Right.Legacyable' | translate }}</mat-checkbox>
                            }
                            @if (!isExternal) {
                                <mat-checkbox class="primary-button" formControlName="legacy">{{ 'Right.Legacy' | translate }}</mat-checkbox>
                            }
                            @if (!isExternal) {
                                <button
                                    mat-icon-button
                                    type="button"
                                    matTooltip="{{ 'Right.DeleteRight' | translate }}"
                                    (click)="DeleteRight(right.controls.name.value, i)"
                                    [disabled]="right.controls['value'].disabled || right.controls['legacy'].value === true"
                                    class="primary-button">
                                    @if (!readonly) {
                                        <mat-icon>disabled_by_default</mat-icon>
                                    }
                                </button>
                            }
                        </div>
                    </div>
                }
            </mat-card-content>
        </mat-card>
    </div>
</div>
